import { ManageApis } from "../../common/APIS/ManageApis"
import { customLogger, FailedPopup } from "../../common/Utils/Utils"

export const handleGetChitDetails = async({setloading, reqstBody, token}) => {
    try {
        setloading(true)
        let response = await ManageApis("post", global.getChitDetails, reqstBody, token)
        if (response.message == 'Success') {
            customLogger("res", response)
            setloading(false)
            if (response.response_data.status) {
                //debugger
                return response.response_data.data.chittal_details
            } else {
                FailedPopup(response)
            }
        } else {
            setloading(false)
            FailedPopup(response)
        }
        return null
    } catch (error) {
        console.log("error", error)
        FailedPopup(error)    
        return null
    }
}